<template>
  <v-card-text class="mt-n3 font-weight-medium" >
    <span v-if="Articulo[0].Condicion !== ''">
      <span
        :class="[ 'text-uppercase font-weight-medium logomoneda mt-0 ml-0' ]"
      >
        {{ Articulo[0].Condicion }}
      </span>
      <br />
      <span v-if="Articulo[0].FchProx !== null">
        <span :class="['body-2']">
          {{ fechaProx() }}
        </span>
        <br />
      </span>
    </span>
    <span
      :class="[
        'text-uppercase font-weight-medium logomoneda mt-0 ml-0',
        {
          'text-decoration-line-through text--secondary':
          Articulo[0].Promocion,
        },
      ]"
    >
      {{ `${Articulo[0].TipoPrecio} ${simboloMoneda[tipoMoneda]}` }}
      {{
        precio({ value: Articulo[0].Precio[tipoMoneda]})
      }}
    </span>
    <span
      v-if="Articulo[0].Precio[tipoMoneda]!==0"
      :class="['logomoneda text-uppercase text--secondary']"
    >
      {{ Articulo[0].Iva === 0 ? "| Exento de IVA" : "| No incluye IVA" }}
    </span>
  </v-card-text>
</template>

<script>
  import { formatMiles } from "../../static/funciones";
  import { mapState } from "vuex";
  export default {
    methods: {
      formatMiles,
    },
    computed: {
      ...mapState(["Articulo", "simboloMoneda", "tipoMoneda"]),
      fechaProx() {
        return () => {
          const fecha = new Date(this.Articulo[0].FchProx);
          const fchprox = fecha.toLocaleDateString('es-ES', {
            day: '2-digit',
            month: '2-digit', 
            year: '2-digit'
          });

          return fchprox;
        }
      },
      precio() {
        return function ({ value }) {
          const precioFormat = this.formatMiles({
                value: value,
                numDecimal: 2,
              })
          return precioFormat;
        };
      },
    },
  };
</script>

<style scoped>
.logomoneda {
  font-size: 1.2rem;
  vertical-align: top;
  line-height: 30px;
  margin: 0 5px;
  color: black;
}
</style>
